import { IIdentity } from '.';

export type ModifyIdentity<T> = Omit<T, 'id'> & IIdentity;
